<template>
  <div class="plan-box plan-basic">
    <h2>Gekko Basic</h2>
    <!-- <div class="plan-subtitle">
      {{ $gettext('For those who need good and unlimited basic accounting.') }}
    </div> -->
    <div class="price-wrap">
      <div class="main-price">
        {{ $gettext('Free') }}
      </div>
      <div class="price-breakdown">
        {{ $gettext('This is your current plan.') }}
      </div>
    </div>

    <div v-if="showFeatures" class="features-box">
      <p>{{ $gettext('Gekko Basic free includes') }}</p>
      <ul class="feature-list">
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Track hours (including mobile app)') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Timeline of your hours per client and project') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Track costs (including mobile app)') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Scan your receipts with the mobile app') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Track trips (including mobile app)	') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Send unlimited invoices') }}</p></li>
        <li><font-awesome-icon icon="fa-solid fa-check" /><p>{{ $gettext('Profit & Loss and hours reporting') }}</p></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanBoxBasic',
  data () {
    return {
      showFeatures: false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
